'use client';

import { ReactNode, useCallback, useEffect, useRef } from 'react';

import { getClientEnv } from '@/config/clientEnv';
import { generateApproperiateURL } from '@/helpers/utils/urlHelpers';
import { useAppDispatch } from '@/store';
import { setWebAlias, setWebAliasLoadingStatus } from '@/store/slices/webalias';

export default function ValidateWebalias({ children }: { children: ReactNode }) {
  const dispatch = useAppDispatch();
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const validateWebalias = useCallback(async () => {
    const { IS_BACKOFFICE, WEBALIAS, SERVER_URL, HOST, ORIGIN, URL_PATH_WITHOUT_WEBALIAS } = getClientEnv();

    if (!HOST || !ORIGIN) {
      console.error('HOST or ORIGIN is not defined - queing ValidateWebalias');
      if (!IS_BACKOFFICE) {
        dispatch(setWebAliasLoadingStatus(true));
      }
      timeoutRef.current = setTimeout(() => {
        validateWebalias();
        clearTimeout(timeoutRef.current!);
      }, 500);
      return;
    }

    let webalias = WEBALIAS;
    try {
      if (!IS_BACKOFFICE) {
        dispatch(setWebAliasLoadingStatus(true));
        const webalias_api_call = await fetch(`${SERVER_URL}/App/ValidateWebAlias?webAlias=${webalias}`, {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: {
            __origin: ORIGIN,
            __host: HOST,
            HOST,
            ORIGIN,
          },
        });
        const webalias_resp_data = ((await webalias_api_call.json()) || {}) as {
          success: boolean;
          data: string;
        };

        dispatch(setWebAliasLoadingStatus(false));

        webalias = webalias_resp_data.data;

        console.log(WEBALIAS, 'is the raw_webalias', webalias, 'is the final webalias from backend API');

        if (webalias != WEBALIAS) {
          console.log('webaliases did not match. redirecting to the webalias provided by the backend');

          // Preserve query parameters during webalias redirect
          const currentUrl = new URL(window.location.href);
          const pathWithQuery = currentUrl.pathname + currentUrl.search;
          const urlWithoutWebalias = pathWithQuery.replace(/^\/[^\/\?]+/, '');
          const newUrl = generateApproperiateURL(urlWithoutWebalias, webalias);

          console.log('Preserving query params during webalias redirect:', newUrl);
          window.history.replaceState(null, '', newUrl);
        }
      } else {
        webalias = 'shopping';
        console.log(webalias, 'backoffice case: setting webalias manually');
      }

      dispatch(setWebAlias(webalias));

      dispatch(setWebAliasLoadingStatus(false));
    } catch (error) {
      dispatch(setWebAliasLoadingStatus(false));
      console.log(`error occured while fetching webalias: `, error);
    }
  }, [dispatch]);

  useEffect(() => {
    const validate = validateWebalias;

    validate();
  }, [validateWebalias]);

  return <>{children}</>;
}
